// imports
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Utils from '../../common/utils';
import { LINKS } from '../../constants';
import { ICON, IMAGE } from '../../assets';
import { BackpackItem } from '../../common/types';
import { selectUserBackpack } from '../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  selected: boolean;
  disabled: boolean;
  item: BackpackItem;
  onClicked: () => void;
}

// exports
export default function ItemCard(props: Props): JSX.Element {
  const {
    item: { id, name, chainMetaId }, selected = false, onClicked, disabled
  } = props;
  const { items } = useSelector(selectUserBackpack);
  // render
  return (
    <button type="button" className="item-card-container" onClick={onClicked} disabled={disabled}>
      <div className={clsx('card', selected && 'selected')}>
        <div className={clsx('body', items[id] <= 0 && 'greyscale')}>
          <div className="avatar-container sheen-overlay">
            <img
              alt="avatar"
              className="avatar"
              src={`${LINKS.BACKPACK_BUCKET_URL}/${id}.png`}
              onError={({ currentTarget }) => { currentTarget.src = IMAGE.ITEM_PLACEHOLDER; }}
            />
            <div className="quantity">{`x ${Utils.string.formatNumber(items[id])}`}</div>
          </div>
          <div className="name">{name}</div>
          {!Utils.dom.isBackpack()
            && (
              <a
                className="opensea"
                target="_blank"
                rel="noreferrer"
                href={`${LINKS.OPEN_SEA_COLLECTION_LOOT}/${chainMetaId}`}
                onClick={(e) => e.stopPropagation()}
              >
                <img className="opensea-icon" src={ICON.OPEN_SEA} alt="opensea" />
              </a>
            )}
        </div>
      </div>
    </button>
  );
}
